import dayjs from "dayjs"
import {   setDoc } from "firebase/firestore";
import { FIRESTORE_COLLECTIONS } from "~~/interface/FirestoreCollections";


export default defineNuxtPlugin(() => {
  return
  if (process.client) {
    // ป้องกันไม่ให้รันซ้ำหากเคยเริ่ม interval ไปแล้ว
    if (window.__statusCheckOnlineIntervalStarted__) return;
    window.__statusCheckOnlineIntervalStarted__ = true;

    const runCheckOnline = () => {
      if (!navigator.onLine) {
        return;
      }

      const key = dayjs().add(7,'hour').toISOString()
      const payload = {[key]: true }
      updateTimeToFirestore(payload)
    }

    function updateTimeToFirestore(data:any){
      const firestoreDb = useFirebaseFirestore();
      const subDocId = dayjs().format("YYYY-MM-DD")
      let ref = firestoreDb.subCollectionDocIdRef(FIRESTORE_COLLECTIONS.CHECK_ONLINE, subDocId)  
      setDoc(ref, data, { merge: true });
    }

    runCheckOnline();
    setInterval(runCheckOnline, 60 * 1000);
  }
});
